export default "__VITE_ASSET__DOcLkfxC__"